import api from './api';

export const register = async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
};

export const verifyOtp = async (otpData) => {
    const response = await api.post('/auth/verify-otp', otpData);
    return response.data;
};

export const resendOtp = async (email) => {
    const response = await api.post('/auth/resend-otp', { email });
    return response.data;
};

export const login = async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
};

export const forgotPassword = async (email) => {
    const response = await api.post('/auth/forgotpassword', { email });
    return response.data;
};

export const resetPassword = async (resetData) => {
    const response = await api.put('/auth/resetpassword', resetData);
    return response.data;
};
